import { AuthService, ProductService } from "../../../../shared/services";
import React, { FC } from "react";
import TickIcon from "../../../../../../../images/common/tick-green.svg";
import CrossIcon from "../../../../../../../images/products/cross-red.svg";
import { observer } from "mobx-react";
import InventoryOnHandPopUp from "./variants/InventoryOnHandPopUp";
import {
  CustomLabel,
  FlexContainer,
  IOption,
  SingleSelect,
  StyledTooltip,
  ToastService,
} from "@mindmemobile/mm-shared-global";
import { InventorySettings } from "../../../../shared/models";
import EditIcon from "../../../../../../../images/products/edit-blue.svg";
import { RolesAndPermissionStore } from "../../../../shared/store";

type IProps = {
  inventorySettings?: InventorySettings;
  hasVariants: boolean;

  rolesAndPermissionStore: RolesAndPermissionStore;
  productId: string;
  isTrackInventory: boolean;
  onUpdate: (settings: InventorySettings) => void;
};

const ItemInventorySection: FC<IProps> = ({
  isTrackInventory,
  inventorySettings,
  hasVariants,
  productId,
  onUpdate,
  rolesAndPermissionStore,
}) => {
  const [showOnHandPopUp, setShowOnHandPopUp] = React.useState(false);
  const row = (
    label: string,
    rightColumn: string | React.ReactNode
  ): React.ReactNode => {
    return (
      <div>
        <FlexContainer alignItems="center">
          {/* {rightColumn} */}
          <img
            src={rightColumn == "yes" ? TickIcon : CrossIcon}
            className="yes-no-icon"
          />
          <CustomLabel>{label}</CustomLabel>
        </FlexContainer>
      </div>
    );
  };

  function onSingleSelectChange(field: string, value: string) {
    switch (field) {
      case "isInStock":
        if (!rolesAndPermissionStore.hasManagePermission("Edit")) return;
        ProductService.updateInventorySettings(
          AuthService.authData.accountId,
          productId,
          inventorySettings?.available || 0,
          value === "InStock" ? true : false
        ).subscribe({
          next: (response) => {
            if (response) {
              onUpdate(
                new InventorySettings({
                  ...inventorySettings,
                  isInStock: value === "InStock",
                })
              );
              ToastService.showSuccess("Updated Successfully");
            } else {
              ToastService.showError("Error Occured");
            }
          },
          error: () => {
            ToastService.showError("Error Occured");
          },
        });
        break;
    }
  }

  function singleSelect(
    field: string,
    selectedKey: string,
    hasError: boolean,
    className: string
  ): React.ReactNode {
    return (
      <SingleSelect
        selectedKey={selectedKey}
        hasError={hasError}
        searchable={false}
        nameKeys={["label"]}
        valueKeys={["value"]}
        options={[
          [
            {
              label: <CustomLabel color="#57AC2D">In Stock</CustomLabel>,
              value: "InStock",
            },
            {
              label: <CustomLabel color="#FF5900">Out of Stock</CustomLabel>,
              value: "OutofStock",
            },
          ],
        ]}
        onChange={(option: IOption) =>
          onSingleSelectChange(field, option.value)
        }
        className={`in-stock-dpdn ${className}`}
      />
    );
  }
  return (
    <>
      {showOnHandPopUp && (
        <InventoryOnHandPopUp
          productId={productId}
          isInStock={inventorySettings?.isInStock == true}
          quantity={inventorySettings?.available || 0}
          onClose={() => setShowOnHandPopUp(false)}
          onUpdate={(quantity, isInStock) => {
            onUpdate(
              new InventorySettings({
                ...inventorySettings,
                isInStock: isInStock,
                available: quantity,
              })
            );
          }}
        />
      )}
      <FlexContainer alignItems="center" justifyContent="space-between">
        <CustomLabel fontSize="20px" fontWeight="600" margin="30px 0px 30px">
          Inventory
        </CustomLabel>
        {!hasVariants && isTrackInventory && (
        <FlexContainer justifyContent="flex-end" alignItems="center" spacing={5}>
          <CustomLabel fontSize="18px">
            <span className="orange-semi-bold">
              {inventorySettings?.available || 0}
            </span>{" "}
            On Hand{" "}
          </CustomLabel>
          <StyledTooltip tooltipText="Edit">
            <img
              src={EditIcon}
              onClick={() => setShowOnHandPopUp(true)}
              className="on-hand-edit"
            />
          </StyledTooltip>
        </FlexContainer>
        )}

        {!isTrackInventory && !hasVariants && (
          <>
            {singleSelect(
              "isInStock",
              inventorySettings?.isInStock ? "InStock" : "OutofStock",
              false,
              "inventory-select dpdn-no-border dpdn-no-separator "
            )}
          </>
        )}
      </FlexContainer>
      <FlexContainer spacing={15} fxLayout="column">
        {row("Track Inventory", isTrackInventory ? "yes" : "No")}
        {row(
          "Continue selling when out of stock",
          inventorySettings?.isSellOnOutOfStock ? "yes" : "no"
        )}
        {row(
          "Promote when inventory is low",
          inventorySettings?.isPromote ? "yes" : "no"
        )}
        {inventorySettings?.isLimitPurchaseQuantity && (
          <>
            {row(
              `Limit to ${inventorySettings.quantityLimit} items per order`,
              ""
            )}
          </>
        )}
      </FlexContainer>
    </>
  );
};
export default observer(ItemInventorySection);
